// Mirror of App\Enums\HorseMemberRelation (campdraftone-api) — how a member is linked to a horse.
// Shared by the Member Profile "Horses" tab (CAM-1505) and the Horse Profile "Members" tab
// (CAM-1504) so the three values/options aren't hand-typed twice. Keep in sync by hand; there is
// no shared source of truth across the two repos.
//
// Labels ARE kept here (unlike e.g. draftStatus.js) — `is_owner`/`is_rider` are two independent
// per-row booleans, not one `*_id` column, so there is no single resource field to hang a
// `*_label` off; "Family" itself is derived client-side too (neither flag true).
export const HORSE_MEMBER_RELATION_OWNER = 'owner'
export const HORSE_MEMBER_RELATION_RIDER = 'rider'
export const HORSE_MEMBER_RELATION_FAMILY = 'family'

// Ready-made options for FilterMultiselect's `relation` filter.
export const HORSE_MEMBER_RELATION_OPTIONS = [
  { id: HORSE_MEMBER_RELATION_OWNER, name: 'Owner' },
  { id: HORSE_MEMBER_RELATION_RIDER, name: 'Rider' },
  { id: HORSE_MEMBER_RELATION_FAMILY, name: 'Family' }
]



// WEBPACK FOOTER //
// ./src/constants/horseMemberRelation.js